var escapeRegExp = require("./escapeRegExp");
module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return "\\s";
  else if (characters.source)
    return characters.source;
  else
    return "[" + escapeRegExp(characters) + "]";
};
